export default "__VITE_ASSET__D6a8eWhA__";